import React from 'react';
import PropTypes from 'prop-types';
import {DragSource} from 'react-dnd';

const Types = {
    ITEM: 'item'
};

const getDataFromNode = function (node) {
    return ['title', 'id', 'src', 'x', 'y', 'sprite_image'].reduce(
        (data, key) => {
            return {...data, [key]: node.attr[key]};
        }, {}
    );
};

const boxSource = {
    beginDrag: props => {
        return props;
    }
};

export class DdObjectNode extends React.Component {
    constructor(props) {
        super(props);
        const graphicState = props.selected ? 'selected' : '';
        this.state = {
            ...getDataFromNode(props.node),
            height: 0,
            graphicState,
        };
    }

    onImgLoad({target: img}) {
        const {sprite_image} = this.state;
        if (sprite_image) {
            // source image is a sprite image (a single image containing 5 elements).
            this.setState({height: parseInt(img.offsetHeight) / 5});
        } else {
            // source image contains a single element
            this.setState({height: parseInt(img.offsetHeight)});
        }
    }

    onButtonMouseOver() {
        if (this.state.graphicState !== 'selected') {
            this.setState({
                graphicState: 'hover'
            });
        }
    }

    onButtonMouseOut() {
        if (this.state.graphicState !== 'selected') {
            this.setState({
                graphicState: ''
            });
        }
    }

    backgroundPosition() {
        const {graphicState, sprite_image, height,} = this.state;

        //if no other sprites exist (non_sprite_image), then we don't shift the image
        if (!sprite_image){
            return '0 0';
        }
        // On April 8th according to PITSCO, ALL sprite images, for ALL node types have the following index
        // properties: 1 -base, 2 - base, 3 - active, 4 - hover, 5 - disabled => array equivalent [0,1,2,3,4]
        // IF the sprite images appear in an incorrect order, forward ticket back to Pitsco and notify them that
        // sprite image order is incorrect, and send them index order which would replicate FRE functionality
        // DO NOT use Transformers!
        if (graphicState === 'selected') {
            // graphicState selected corresponds to 3 - Active state
            return `0 -${parseInt(height) * 2}px`;
        } else if (graphicState === 'hover') {
            // graphicState hover corresponds to 4 - hover (mouseOver) state
            return `0 -${parseInt(height) * 3}px`;
        } else if (graphicState === 'disabled') {
            // graphicState disabled corresponds to 5 - Disabled state
            return `0 -${parseInt(height) * 4}px`;
        } else {
            // Selected is null; ->
            // BASE state corresponds to 1 - base and 2 - base
            return '0 0';
        }
    }

    render() {
        const {moduleURL = '', connectDragSource, isDropped = false} = this.props;
        let {height = 0, src, x, y} = this.state;
        const divStyle = {
            display: isDropped ? 'none' : 'block',
            top: `${y}px`,
            left: `${x}px`,
            height: height,
            cursor: 'pointer',
            background: `url(${moduleURL}/media/${src}) no-repeat`,
            backgroundPosition: this.backgroundPosition(),
        };

        return connectDragSource(
            <div className="node dd-node" style={divStyle} onMouseOut={this.onButtonMouseOut.bind(this)}
                 onMouseOver={this.onButtonMouseOver.bind(this)}>
                <img onLoad={this.onImgLoad.bind(this)} src={`${moduleURL}/media/${src}`} className={'visibility-hidden'}/>
            </div>
        );

    }
}

DdObjectNode.propTypes = {
    connectDragSource: PropTypes.func.isRequired,
};

export default DragSource(Types.ITEM, boxSource, connect => ({
    connectDragSource: connect.dragSource(),
}))(DdObjectNode);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/dd-object-node.js